import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';

// eslint-disable-next-line
// @ts-ignore
Vue.use(VueCompositionAPI);
